var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00546 20C4.7286 20 4.49195 19.9015 4.29552 19.7045C4.09851 19.5081 4 19.2714 4 18.9945V13.7486C4 13.4718 4.09851 13.2351 4.29552 13.0387C4.49195 12.8417 4.7286 12.7432 5.00546 12.7432C5.28233 12.7432 5.51898 12.8417 5.71541 13.0387C5.91242 13.2351 6.01093 13.4718 6.01093 13.7486V16.612L16.612 6.01093H13.7486C13.4718 6.01093 13.2351 5.91242 13.0387 5.71541C12.8417 5.51898 12.7432 5.28233 12.7432 5.00546C12.7432 4.7286 12.8417 4.49166 13.0387 4.29464C13.2351 4.09822 13.4718 4 13.7486 4H18.9945C19.2714 4 19.5081 4.09822 19.7045 4.29464C19.9015 4.49166 20 4.7286 20 5.00546V10.2514C20 10.5282 19.9015 10.7649 19.7045 10.9613C19.5081 11.1583 19.2714 11.2568 18.9945 11.2568C18.7177 11.2568 18.481 11.1583 18.2846 10.9613C18.0876 10.7649 17.9891 10.5282 17.9891 10.2514V7.38798L7.38798 17.9891H10.2514C10.5282 17.9891 10.7649 18.0876 10.9613 18.2846C11.1583 18.481 11.2568 18.7177 11.2568 18.9945C11.2568 19.2714 11.1583 19.5081 10.9613 19.7045C10.7649 19.9015 10.5282 20 10.2514 20H5.00546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.ccab3fc1ca0ef5867cb56cb4cc367e9e.svg";
export { ForwardRef as ReactComponent };